import { render, staticRenderFns } from "./iconDeleteReview.vue?vue&type=template&id=7a59c7e7&scoped=true"
import script from "./iconDeleteReview.vue?vue&type=script&lang=js"
export * from "./iconDeleteReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a59c7e7",
  null
  
)

export default component.exports